<template>
  <div class="error-warning" v-if="isError" :class="bgColor">
    <div class="inner">
      <a class="close" href="#0" @click.prevent="$emit('close')"></a>
      <div class="content">
        <p v-html="message"></p>
        <p v-if="typeof recoverPassword !== 'undefined' && recoverPassword == 'true'"><br><a href="#0" @click.prevent="$emit('close')">Prova di nuovo</a> a inserire la password.<br>Se non la ricordi, <router-link to="/recover">clicca qui</router-link> per impostarne una nuova.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isError', 'message', 'bgColor', 'recoverPassword']
}
</script>

<style lang="scss" scoped>
  @import './../css/variables.css';

  .inner {
    margin: auto;
    position: relative;
  }

  .error-warning {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    background: rgba(255, 255, 255, 0.7);

    &.aqua {
      .inner {
        background: var(--aqua);
      }
    }

    &.white {
      .inner {
        background: white;
      }
    }
  }

  .content {
    padding: 60px 20px;
    margin: 0;

    p {
      margin: 0 !important;
      padding: 0;
    }
  }

  p {
    a {
      border-bottom: 2px solid;
      transition: 0.3s all;

      &:hover {
        border-bottom-color: transparent;
      }
    }
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    display: block;
    width: 40px;
    height: 40px;

    &::after,
    &::before {
      display: block;
      width: 40px;
      height: 2px;
      content: '';
      position: absolute;
      background: black;
      top: 20px;
      left: 0;
    }

    &::after {
      transform: rotate(45deg);
    }

    &::before {
      transform: rotate(-45deg);
    }
  }

  @media (min-width: 768px) {
    .content {
      padding: 60px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/vue/components/ErrorWarning.vue